import type { CSSProperties } from 'react';
import FilledCaretDownIconSvg from '../../assets/icons/filled_caret_down.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const FilledCaretDownIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <FilledCaretDownIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default FilledCaretDownIcon;
